export const appendToFormData = (formData, valuesObject) => {
  for (const property in valuesObject) {
    if (valuesObject[property]) {
      formData.append(property, valuesObject[property]);
    }
  }
};
